import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RunwayService } from '../service/runway.service';
import { EditRunwayComponent } from '../edit-runway/edit-runway.component';

@Component({
  selector: 'app-delete-runway',
  templateUrl: './delete-runway.component.html',
  styleUrls: ['./delete-runway.component.scss']
})
export class DeleteRunwayComponent implements OnInit {
  runwayId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditRunwayComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _runwayService: RunwayService) {
    this.runwayId = data.runwayId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._runwayService.deleteRunway(this.airportId, this.runwayId);
      this.isLoading = false;
      this.close({success: true, runwayId: this.runwayId});
    } catch (e) {
      this.close({success: false, error: e});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
